@if (!desktop) {
  <ion-item
    [class.text-red]="submitted && ((address && !address.postalCode) || !address)"
    >
    <p style="white-space: pre">
      {{ text }}
    </p>
    <ion-icon name="arrow-forward" slot="end"></ion-icon>
  </ion-item>
}
@if (desktop) {
  <div style="margin-bottom: 2px">
    <!-- change to button -->
    <div
      style="padding: 5px; background: lightgrey; width: 100%"
    [class.text-red]="
      submitted && ((address && !address.postalCode) || !address)
    "
      >
      <form
        style="display: flex; align-items: center; justify-content: space-between"
        novalidate
        [formGroup]="form"
        >
        <p style="margin: 0; font-size: 0.8rem">
          {{ text }}
        </p>
        <div
          class="custom-form-group"
          style="margin: 0 1px 0 0; display: flex; align-items: center"
          >
          <input
            formControlName="postalCode"
            type="text"
            placeholder="{{ 'Address.PostalCode' | translate }}"
          style="
            margin-left: 3px;
            background: whitesmoke;
            border: 1px solid lightgrey;
          "
            />
            <ion-button
              type="submit"
              style="background: whitesmoke; height: 25px; border-radius: 3px"
              (click)="beginChangeAddress()"
              [disabled]="!form.valid"
              >
              Search
              <!-- <ion-icon
              name="arrow-forward"
              (click)="beginChangeAddress()"
            ></ion-icon> -->
          </ion-button>
        </div>
      </form>
    </div>
  </div>
}
